import type { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { GovernmentDataBrick } from './GovernmentDataBrick';

export const GovernmentDataBrickWithData: FunctionComponent = () => {
  const propertyPage = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  if (!propertyPage?.governmentDataV2) return null;

  const {
    title,
    subtitle,
    landDescription,
    overlayTiles,
    overlaySummary,
    showMoreButton,
    moreInformation,
  } = propertyPage.governmentDataV2;

  return (
    <GovernmentDataBrick
      title={title}
      subtitle={subtitle}
      landDescription={landDescription}
      overlayTiles={overlayTiles}
      overlaySummary={overlaySummary}
      showMoreButton={showMoreButton?.title}
      moreInformation={moreInformation}
    />
  );
};
